import { createUseStyles } from "react-jss";
import { colors } from "../../../styles/colors";
import { down } from "../../../styles/breakpoints";
import { cardGrid } from "../../../styles/pageShell";

const useStyles = createUseStyles((_) => ({
  divContainerFleet: cardGrid(260),

  divFleet: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "20px",
    borderRadius: "15px",
    /* 30px of padding on a 320px phone left ~260px of usable card. */
    padding: "30px",
    minWidth: 0,
    backgroundColor: colors.WHITE,
    boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.09)",
    "& > div": {
      flex: "1 1 160px",
      minWidth: 0,
    },
    [down.sm]: {
      padding: "20px",
      gap: "16px",
    },
  },

  divUsers: {
    display: "flex",
    flexDirection: "column",
    gap: "35px",
    minWidth: 0,
    [down.sm]: {
      gap: "20px",
    },
  },

  divChiffre: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    minWidth: 0,
  },

  divRecharts: {
    display: "flex",
    alignItems: "flex-end",
    minWidth: 0,
    /* Recharts renders a fixed-size SVG; let it shrink rather than push the
       card wider than its grid column. */
    "& svg": {
      maxWidth: "100%",
    },
  },
}));

export default useStyles;
